/* eslint-disable */
/* tslint:disable */
export const CategoryTree = {
    "Audio": [
        "DJ Equipment",
        "Headphones & Headsets",
        "Headphones Accessories",
        "Home Audio",
        "Home Audio Accessories",
        "Portable Players",
        "Portable Speakers",
        "Portable Speakers Accessories",
        "Professional Audio Accessories",
        "Professional Audio Equipment",
        "Turntables"
    ],
    "Bags and Travel": [
        "Kids Bags",
        "Men Bags",
        "Travel",
        "Women Bags"
    ],
    "Beauty": [
        "Beauty Tools",
        "Fragrances",
        "Makeup",
        "Men's Care",
        "Personal Care",
        "Skin Care"
    ],
    "Bedding & Bath": [
        "Bath",
        "Bedding"
    ],
    "Cameras & Drones": [
        "Bridge",
        "DSLR",
        "Drones",
        "Gadgets & Other Cameras",
        "Instant Camera",
        "Lenses",
        "Mirrorless",
        "Optics",
        "Point & Shoot",
        "Security Cameras & Systems",
        "Video & Action Camcorder"
    ],
    "Computers & Laptops": [
        "Desktops Computers",
        "Laptops"
    ],
    "Data Storage": [
        "External Solid State Drives",
        "External hard Drives",
        "Flash Drives",
        "Internal Hard Drives",
        "Internal Solid State Drives",
        "Memory Cards",
        "NAS",
        "OTG Drives",
        "Storage for Mac"
    ],
    "Digital Goods": [
        "Digital Games and Software",
        "Digital Media",
        "Digital Vouchers",
        "Event Ticketing",
        "Financial Services",
        "Gift Cards",
        "Lazada Gift Cards",
        "Travel",
        "Travel Essentials"
    ],
    "Digital Utilities": [
        "Education",
        "Entertainment",
        "Financial",
        "Household",
        "Internet & Phone Services",
        "Payment Processes",
        "Transportation"
    ],
    "Electronics Accessories": [
        "Camera Accessories",
        "Computer Accessories",
        "Computer Components",
        "Drone Accessories",
        "Instant Camera Accessories",
        "Lens Accessories",
        "Mobile Accessories",
        "Network Components",
        "Optics Accessories"
    ],
    "Fashion Accessories": [
        "Eyewear",
        "Fashion Jewellery",
        "Fine Jewellery",
        "Investment Precious Metal",
        "Men Accessories",
        "Umbrellas & Raincoats",
        "Watches",
        "Women Accessories"
    ],
    "Food - Caterers": [
        "American",
        "Asian",
        "Brazilian",
        "Burgers",
        "Cakes & Bakery",
        "Chicken",
        "Chinese",
        "Desserts",
        "Fast Food",
        "Filipino",
        "French",
        "German",
        "Greek",
        "Healthy Food",
        "Indian",
        "International",
        "Italian",
        "Japanese",
        "Korean",
        "Mediterranean",
        "Mexican",
        "Middle Eastern",
        "Non-alcoholic Drinks",
        "Pizza",
        "Sandwiches",
        "Seafood",
        "Singaporean",
        "South East Asian",
        "Spanish",
        "Sushi",
        "Thai",
        "Vegetarian",
        "Vietnamese",
        "Western"
    ],
    "Food - Home Based Kitchen": [
        "American",
        "Asian",
        "Brazilian",
        "Burgers",
        "Cakes & Bakery",
        "Chicken",
        "Chinese",
        "Desserts",
        "Fast Food",
        "Filipino",
        "French",
        "German",
        "Greek",
        "Healthy Food",
        "Indian",
        "International",
        "Italian",
        "Japanese",
        "Korean",
        "Mediterranean",
        "Mexican",
        "Middle Eastern",
        "Non-alcoholic Drinks",
        "Pizza",
        "Sandwiches",
        "Seafood",
        "Singaporean",
        "South East Asian",
        "Spanish",
        "Sushi",
        "Thai",
        "Vegetarian",
        "Vietnamese",
        "Western"
    ],
    "Food - Regular Restaurant": [
        "American",
        "Asian",
        "Brazilian",
        "Burgers",
        "Cakes & Bakery",
        "Chicken",
        "Chinese",
        "Desserts",
        "Fast Food",
        "Filipino",
        "French",
        "German",
        "Greek",
        "Healthy Food",
        "Indian",
        "International",
        "Italian",
        "Japanese",
        "Korean",
        "Mediterranean",
        "Mexican",
        "Middle Eastern",
        "Non-alcoholic Drinks",
        "Pizza",
        "Sandwiches",
        "Seafood",
        "Singaporean",
        "South East Asian",
        "Spanish",
        "Sushi",
        "Thai",
        "Vegetarian",
        "Vietnamese",
        "Western"
    ],
    "Food - Street Food": [
        "American",
        "Asian",
        "Brazilian",
        "Burgers",
        "Cakes & Bakery",
        "Chicken",
        "Chinese",
        "Desserts",
        "Fast Food",
        "Filipino",
        "French",
        "German",
        "Greek",
        "Healthy Food",
        "Indian",
        "International",
        "Italian",
        "Japanese",
        "Korean",
        "Mediterranean",
        "Mexican",
        "Middle Eastern",
        "Non-alcoholic Drinks",
        "Pizza",
        "Sandwiches",
        "Seafood",
        "Singaporean",
        "South East Asian",
        "Spanish",
        "Sushi",
        "Thai",
        "Vegetarian",
        "Vietnamese",
        "Western"
    ],
    "Furniture & Organization": [
        "Furniture",
        "Storage & Organisation"
    ],
    "Groceries": [
        "Alcoholic Beverages",
        "Bakery",
        "Breakfast Cereals & Spreads",
        "Chocolate, Snacks & Sweets",
        "Dairy & Chilled",
        "Drinks",
        "Food Staples & Cooking Essentials",
        "Frozen",
        "Fruit & Vegetables",
        "Meat & Seafood",
        "Tobacco"
    ],
    "Health": [
        "Adult Diapers & Incontinence",
        "Food Supplement",
        "Medical Supplies",
        "Sexual Wellness"
    ],
    "Household Supplies": [
        "Air Care",
        "Cleaning Supplies",
        "Dishwashing",
        "Household Sundries",
        "Kitchen Supplies",
        "Laundry Supplies",
        "Paper & Tissue",
        "Pest Control"
    ],
    "Kids' Shoes and Clothing": [
        "Boy's Clothing",
        "Boy's Shoes",
        "Girl's Clothing",
        "Girl's Shoes"
    ],
    "Kitchen & Dining": [
        "Bakeware",
        "Coffee & Tea",
        "Cookware",
        "Cutlery",
        "Dinnerware",
        "Disposables",
        "Drinkware",
        "Kitchen & Table Linen",
        "Kitchen Storage & Accessories",
        "Kitchen Utensils",
        "Serveware"
    ],
    "Large Appliances": [
        "Air Conditioners",
        "Built-in Oven",
        "Clothes Dryers",
        "Combo Washer Dryer",
        "Cooktops & Ranges",
        "Dish Dryers & Sterilizers",
        "Dishwashers",
        "Freezers",
        "Microwaves",
        "Range Hoods",
        "Refrigerators",
        "Warming Drawers",
        "Washing Machines",
        "Water Dispensers",
        "Water Purifiers Systems",
        "Wine Cellars"
    ],
    "Laundry & Cleaning Equipment": [
        "Cleaning Tools",
        "Laundry Tools & Accessories"
    ],
    "Lighting & Décor": [
        "Home Décor",
        "Lighting"
    ],
    "Media, Music & Books": [
        "Books",
        "Magazines",
        "Movies",
        "Music",
        "Musical Instruments",
        "TV Series"
    ],
    "Men's Shoes and Clothing": [
        "Men Clothing",
        "Men Shoes"
    ],
    "Mobiles & Tablets": [
        "Feature Phones",
        "Landline Phones",
        "Smartphones",
        "Tablets"
    ],
    "Monitors & Printers": [
        "3D Printing",
        "Fax machines",
        "Ink",
        "Monitor Screen Filters",
        "Monitor Stands",
        "Monitors",
        "Other Printer Parts & Accessories",
        "Printer Covers",
        "Printer cutter",
        "Printer memory modules",
        "Printer stands",
        "Printers",
        "Scanners"
    ],
    "Mother & Baby": [
        "Baby Gear",
        "Baby Health Care",
        "Baby Personal Care",
        "Baby Safety",
        "Clothing & Accessories",
        "Diapering & Potty",
        "Feeding Essentials",
        "Gifts",
        "Maternity Care",
        "Milk Formula & Baby Food",
        "Nursery",
        "Pacifiers & Accessories"
    ],
    "Motors": [
        "Automotive",
        "Motorcycle"
    ],
    "Outdoor & Garden": [
        "Lawn & Garden",
        "Outdoor"
    ],
    "Pet Supplies": [
        "Pet Accessories",
        "Pet Food",
        "Pet Healthcare"
    ],
    "Services": [
        "Home Services",
        "Seller Services"
    ],
    "Small Appliances": [
        "Home Appliances Parts",
        "Personal Care Appliances",
        "Small Cooling & Air Treatment",
        "Small Household Appliances",
        "Small Kitchen Appliances"
    ],
    "Smart Devices": [
        "Fitness & Activity Tracker Accessories",
        "Gadgets",
        "Gesture Control",
        "Other Smart Devices",
        "PC VR Accessories",
        "Smart Glasses",
        "Smart Rings",
        "Smart Speakers",
        "Smart Switches",
        "Smart Trackers",
        "Smartwatches & Accessories",
        "Streaming Media Players",
        "Virtual Reality"
    ],
    "Special Digital Products": [
        "Liveup"
    ],
    "Sports & Outdoors": [
        "Exercise & Fitness Equipment",
        "Outdoor Recreation",
        "Sports Equipment",
        "Team Merchandise/Fan Shop"
    ],
    "Sports Shoes and Clothing": [
        "Boys' Sports Accessories",
        "Boys' Sports Bags",
        "Boys' Sports Clothing",
        "Boys' Sports Shoes",
        "Girls' Sports Accessories",
        "Girls' Sports Bags",
        "Girls' Sports Clothing",
        "Girls' Sports Shoes",
        "Men's Sports Accessories",
        "Men's Sports Bags",
        "Men's Sports Clothing",
        "Men's Sports Shoes",
        "Women's Sports Accessories",
        "Women's Sports Bags",
        "Women's Sports Clothing",
        "Women's Sports Shoes"
    ],
    "Stationery, Craft & Gift Cards": [
        "Art Supplies",
        "Craft Supplies",
        "Gifts & Wrapping",
        "Monetary Value Cards",
        "Packaging & Cartons",
        "Paper Products",
        "School & Office Equipment",
        "Sewing",
        "Writing & Correction"
    ],
    "Televisions & Videos": [
        "Analog Televisions",
        "Digital Televisions",
        "Smart Televisions",
        "TV Accessories",
        "Video"
    ],
    "Tools & Home Improvement": [
        "Electrical",
        "Fixtures & Plumbing",
        "Hand Tools",
        "Hardware",
        "Material Handling",
        "Measuring & Levelling",
        "Power Tools",
        "Protective Clothing & Equipment",
        "Safety",
        "Security",
        "Tool Storage & Shelving",
        "Wall Treatment",
        "Work Lights"
    ],
    "Toys & Games": [
        "Action Figures & Collectibles",
        "Arts & Crafts",
        "Baby & Toddler Toys",
        "Building Blocks",
        "Dolls & Accessories",
        "Electronic & Remote Control Toys",
        "Hobbies & Entertainment",
        "Learning & Education",
        "Party Supplies",
        "Pretend Play, Costumes & Party",
        "Sports Toys & Outdoor Play",
        "Stuffed Toys",
        "Traditional Games"
    ],
    "Women's Shoes and Clothing": [
        "Women Clothing",
        "Women Shoes"
    ]
};
